<div [hidden]="isProductMetaDataHidden" class="form-group" ngModelGroup="formField{{ formField.id }}">
    @if (formField.placeholder) {
        <label>{{ formField.placeholder }}</label>
    }
    <input
        [readonly]="isReadOnlyInput"
        type="text"
        class="form-control"
        name="formField{{ formField.id }}"
        [placeholder]="formField.placeholder"
        [(ngModel)]="formField.value" />
</div>
